import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import BadgeStyle from "components/badges/Badge.module.scss";

export const Sapphire = ({size, id, className}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 64 64";
  _attributes.width = _attributes.height = size || 64;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(BadgeStyle["badge"], className);
  } else {
    _attributes.className = BadgeStyle["badge"];
  }

  return (
    <svg {..._attributes}>
      <rect x={0} y={0} width={64} height={64} className={BadgeStyle["badge__canvas"]}/>
      <g>
        <path d="M25.729,10.923l-5.789,6.951l8.051,-2.886l-2.262,-4.065Z" className={BadgeStyle["sapphire__fill1"]} />
        <path d="M25.793,26.315l2.198,-11.328l-8.051,2.886l-0.503,12.22l6.356,-3.778Z" className={BadgeStyle["sapphire__fill3"]} />
        <path d="M19.94,17.874l-5.768,11.534l5.265,0.688l0.503,-12.222Z" className={BadgeStyle["sapphire__fill2"]} />
        <path d="M32,6l-6.27,4.923l2.261,4.065l4.009,-8.988Z" className={BadgeStyle["sapphire__fill6"]} />
        <path d="M25.793,26.315l6.207,-6.161l-4.009,-5.167l-2.198,11.328Z" className={BadgeStyle["sapphire__fill1"]} />
        <path d="M22.128,35.959l-3.39,7.098l5.282,0.81l-0.058,-0.275l0.058,0.275l0.008,0l-1.9,-7.908Z" className={BadgeStyle["sapphire__fill4"]} />
        <path d="M19.437,30.096l2.693,5.863l3.662,-9.643l-6.355,3.78Z" className={BadgeStyle["sapphire__fill4"]} />
        <path d="M24.024,43.866l1.48,6.955l6.496,-2.45l-7.969,-4.504l-0.007,-0.001Z" className={BadgeStyle["sapphire__fill5"]} />
        <path d="M14.172,29.408l-1.851,8.912l7.116,-8.224l-5.265,-0.688Z" className={BadgeStyle["sapphire__fill3"]} />
        <path d="M22.131,35.959l-2.694,-5.863l-7.117,8.224l6.42,4.737l3.391,-7.098Z" className={BadgeStyle["sapphire__fill2"]} />
        <path d="M18.085,52.235l6.384,4.268l1.035,-5.68l-7.419,1.412Z" className={BadgeStyle["sapphire__fill7"]} />
        <path d="M24.47,56.503l7.53,1.495l-6.496,-7.178l-1.034,5.683Z" className={BadgeStyle["sapphire__fill8"]} />
        <path d="M24.024,43.867l-5.284,-0.81l-0.656,9.178l7.42,-1.414l-1.48,-6.954Z" className={BadgeStyle["sapphire__fill9"]} />
        <path d="M12.321,38.32l1.495,7.531l4.922,-2.795l-6.417,-4.736Z" className={BadgeStyle["sapphire__fill9"]} />
        <path d="M13.818,45.851l4.266,6.385l0.656,-9.178l-4.922,2.793Z" className={BadgeStyle["sapphire__fill8"]} />
        <path d="M32,20.155l0,-14.155l-4.009,8.987l4.009,5.168Z" className={BadgeStyle["sapphire__fill3"]} />
        <path d="M25.504,50.821l6.496,7.178l0,-9.627l-6.496,2.449Z" className={BadgeStyle["sapphire__fill9"]} />
        <path d="M38.271,10.923l5.789,6.951l-8.051,-2.886l2.262,-4.065Z" className={BadgeStyle["sapphire__fill1"]} />
        <path d="M38.207,26.315l-2.198,-11.328l8.051,2.886l0.503,12.22l-6.356,-3.778Z" className={BadgeStyle["sapphire__fill5"]} />
        <path d="M44.061,17.874l5.768,11.534l-5.265,0.688l-0.503,-12.222Z" className={BadgeStyle["sapphire__fill7"]} />
        <path d="M32,6l6.271,4.923l-2.261,4.065l-4.01,-8.988Z" className={BadgeStyle["sapphire__fill3"]} />
        <path d="M38.208,26.315l-6.208,-6.161l4.01,-5.167l2.198,11.328Z" className={BadgeStyle["sapphire__fill2"]} />
        <path d="M41.87,35.959l3.39,7.098l-5.283,0.81l0.059,-0.275l-0.059,0.275l-0.008,0l1.901,-7.908Z" className={BadgeStyle["sapphire__fill5"]} />
        <path d="M44.563,30.096l-2.693,5.863l-3.662,-9.643l6.355,3.78Z" className={BadgeStyle["sapphire__fill2"]} />
        <path d="M39.976,43.866l-1.48,6.955l-6.496,-2.45l7.969,-4.504l0.007,-0.001Z" className={BadgeStyle["sapphire__fill5"]} />
        <path d="M49.829,29.408l1.851,8.912l-7.117,-8.224l5.266,-0.688Z" className={BadgeStyle["sapphire__fill8"]} />
        <path d="M41.87,35.959l2.693,-5.863l7.116,8.224l-6.42,4.737l-3.389,-7.098Z" className={BadgeStyle["sapphire__fill9"]} />
        <path d="M45.916,52.235l-6.385,4.268l-1.035,-5.68l7.42,1.412Z" className={BadgeStyle["sapphire__fill8"]} />
        <path d="M39.529,56.503l-7.532,1.495l6.496,-7.178l1.036,5.683Z" className={BadgeStyle["sapphire__fill9"]} />
        <path d="M39.976,43.867l5.284,-0.81l0.656,9.178l-7.42,-1.414l1.48,-6.954Z" className={BadgeStyle["sapphire__fill7"]} />
        <path d="M51.68,38.32l-1.495,7.531l-4.922,-2.795l6.417,-4.736Z" className={BadgeStyle["sapphire__fill7"]} />
        <path d="M50.182,45.851l-4.266,6.385l-0.656,-9.178l4.922,2.793Z" className={BadgeStyle["sapphire__fill8"]} />
        <path d="M41.046,33.79l-2.839,-7.475l-6.207,-6.161l-6.207,6.161l-3.662,9.644l0.608,2.528c6.462,2.161 13.368,-0.151 18.307,-4.697Z" className={BadgeStyle["sapphire__fill6"]} />
        <path d="M22.739,38.488l1.292,5.379l7.969,4.504l7.969,-4.504l1.901,-7.908l-0.824,-2.17c-4.94,4.547 -11.845,6.859 -18.307,4.699Z" className={BadgeStyle["sapphire__fill1"]} />
        <path d="M32,20.155l0,-14.155l4.01,8.987l-4.01,5.168Z" className={BadgeStyle["sapphire__fill6"]} />
        <path d="M38.496,50.821l-6.496,7.179l0,-9.628l6.496,2.449Z" className={BadgeStyle["sapphire__fill8"]} />
        <path d="M40.37,44.27l4.236,-0.402l-4.236,-0.402l-0.402,-4.237l-0.402,4.237l-4.237,0.402l4.237,0.402l0.402,4.237l0.402,-4.237Z" className={BadgeStyle["sapphire__white"]}/>
        <path d="M35.751,16.036l4.236,-0.402l-4.236,-0.403l-0.402,-4.236l-0.402,4.236l-4.237,0.403l4.237,0.402l0.402,4.237l0.402,-4.237Z" className={BadgeStyle["sapphire__white"]}/>
        <path d="M24.292,44.107l2.519,-0.239l-2.519,-0.239l-0.239,-2.52l-0.239,2.52l-2.519,0.239l2.519,0.239l0.239,2.519l0.239,-2.519Z" className={BadgeStyle["sapphire__white"]}/>
      </g>
    </svg>
  );
};

Sapphire.defaultProps = {
  size: 64,
  className: "",
  id: ""
};

Sapphire.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
